import { render, staticRenderFns } from "./abnormalProduct.vue?vue&type=template&id=4ce4c27c&scoped=true&"
import script from "./abnormalProduct.vue?vue&type=script&lang=js&"
export * from "./abnormalProduct.vue?vue&type=script&lang=js&"
import style0 from "./abnormalProduct.vue?vue&type=style&index=0&id=4ce4c27c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4c27c",
  null
  
)

export default component.exports